export const services = [
  {
    imageSrc: "/images/service/home-1.png",
    title: "Buy A New Home",
    description:
      "Discover your dream home effortlessly. Explore diverse properties and expert guidance for a seamless buying experience.",
  },
  {
    imageSrc: "/images/service/home-2.png",
    title: "Sell a home",
    description:
      "Sell confidently with expert guidance and effective strategies, showcasing your property's best features for a successful sale.",
  },
  {
    imageSrc: "/images/service/home-3.png",
    title: "Rent a home",
    description:
      "Discover your perfect rental effortlessly. Explore a diverse variety of listings tailored precisely to suit your unique lifestyle needs.",
  },
];
